import { Radio, Spin } from "antd";
import React from "react";
import { CONSTANTS as C } from "config";
import AppModal from "components/ui/AppModal";
import { useTranslation } from "react-i18next";
import AppButton from "components/ui/AppButton";
import AppRadioButton from "components/ui/AppRadioButton";
function PauseModalContainer({
  PauseModel,
  closeModal,
  setPauseModalState,
  playPauseItem,
  isLoading,
  heading,
  title1,
  title2,
}) {
  const { t } = useTranslation();

  return (
    <>
      <AppModal
        open={PauseModel.open}
        onClose={closeModal}
        title={t(heading)}
        responsiveClass="w-full md:w-2/3 lg:w-2/3 xl:w-2/5 2xl:1/3"
      >
        <Spin spinning={isLoading}>
          <div className="w-full mx-auto my-auto  bg-white">
            <div className="">
              <div className="justify-center">
                <p className="mb-4">
                  {t(title2, {
                    item: title1,
                  })}
                </p>
                <div className="mb-4">
                  <>
                    {C.ITEM_MODIFIER_UNAVAILABLE_DURATIONS.map((op) => {
                      return (
                        <div className="mb-2">
                          <AppRadioButton
                            onChange={(e) =>
                              setPauseModalState("deafaultOption", {
                                value: op.value,
                                unit: op.unit,
                                duration: op.duration,
                              })
                            }
                            title={t(op.title)}
                            value={op.value}
                            checked={
                              PauseModel?.deafaultOption?.value === op.value &&
                              op.unit === PauseModel?.deafaultOption?.unit
                            }
                          >
                          
                          </AppRadioButton>
                        </div>
                      );
                    })}
                  </>
                </div>

                <div className="flex justify-end gap-1 items-center mt-4">
                  <AppButton
                    type="primary"
                    onClick={() =>
                      playPauseItem(
                        PauseModel.modifier,
                        PauseModel?.deafaultOption?.duration
                      )
                    }
                  >
                    {t("Pause")}
                  </AppButton>
                </div>
              </div>
            </div>
          </div>
        </Spin>
      </AppModal>
    </>
  );
}

export default PauseModalContainer;
